import React, { useState } from 'react';
import { FaUser, FaLock, FaEye, FaEyeSlash } from 'react-icons/fa';
import { useFormik } from "formik";
import * as Yup from "yup";
import { doLogin } from '../../services/data/auth-service';
import { toast } from 'react-toastify';
import { useNavigate } from 'react-router-dom';
import PageLoader from '../../componenets/PageLoader';

const loginSchema = Yup.object().shape({
  username: Yup.string().required("Please enter the username"),   
  password: Yup.string().required("Please enter the password"),   
});

const Login = () => {
  const navigate = useNavigate()
  const [loading, setLoading] = useState(false)
  const [initialValues, setInitialValues] = useState({
    username:"",  
    password:""  ,   
  });

  const {
    values,   
    handleChange,
    handleSubmit,
    // handleReset,    
    errors,
    touched,
  } = useFormik({
    initialValues: initialValues,
    validationSchema: loginSchema,
    enableReinitialize:true,
    onSubmit: async (values) => {    
      // console.log(values)  
      setLoading(true)
      localStorage.removeItem('jwt')
      await doLogin(values).then((response) => {
        if (response.data.status === 'success') {
          localStorage.setItem('jwt', response.data.token)            
          toast.success('Login success')
          navigate('/')          
        } else {
          toast.error(response.data.message)
        }
      })
      .catch((error) => {
        toast.error(error.response.data.message)
        initialValues.username = ''
        initialValues.password = ''                  
      })
      .finally(()=>{
        setLoading(false)
      })      
    }
  });
   
  const [showPassword, setShowPassword] = useState(false);

  return (
    <section className='content'>
      {
        loading ? <PageLoader loading="Loading..." /> :(
          <>
            <div className="d-flex vh-100 justify-content-center align-items-center bg-light">
              <div className="card shadow-sm" style={{ width: '24rem' }}>
                <div className="card-header text-center">
                  <h1 className="h4 fw-bold">Login</h1>
                </div>
                <div className="card-body">
                  <form onSubmit={handleSubmit}>
                    <div className="mb-3 position-relative">
                      <FaUser 
                        className="position-absolute start-0 translate-middle-y ms-3 text-secondary" size={20} 
                        style={{top:"18px"}}
                      />
                      <input
                        type="text"
                        name="username"
                        placeholder="Username"
                        className="form-control ps-5"
                        value={values.username}
                        onChange={handleChange}
                      />
                      {errors.username && touched.username && (
                        <b className="text-danger">
                          {errors.username}
                        </b>
                      )}
                    </div>
                    
                    <div className="mb-3 position-relative">
                      <FaLock 
                        className="position-absolute  start-0 translate-middle-y ms-3 text-secondary" size={20} 
                        style={{top:"18px"}}
                      />
                      <input
                        type={showPassword ? "text" : "password"}
                        name="password"
                        placeholder="Password"
                        className="form-control ps-5 pe-5"
                        value={values.password}
                        onChange={handleChange}
                      />
                      {errors.password && touched.password && (
                        <b className="text-danger">
                          {errors.password}
                        </b>
                      )}
                      <span 
                        className="position-absolute end-0 translate-middle-y me-3 text-secondary cursor-pointer"
                        onClick={() => setShowPassword(!showPassword)}
                        style={{ cursor: 'pointer', top:"18px"}}
                      >
                        {showPassword ? < FaEye size={20} /> : <FaEyeSlash size={20} />}
                      </span>
                    </div>                    
                    <button type="submit" className="btn btn-primary w-100">Sign In</button>
                  </form>
                  {/* <div className="text-center mt-3">
                    <a href="#" className="text-muted">Forgot password?</a>
                  </div> */}
                </div>
              </div>
            </div>
          </>
        )
      }
    </section>   
  );
};

export default Login;
